import React, { FC, useMemo, useState } from 'react'
import styles from 'styles/components/list.module.scss'
import { PickupableTimeType } from 'types/bread'
import { OrderBreadTimeList } from 'components/List'
import { useSelector } from 'react-redux'
import { State } from 'index'
import classNames from 'classnames'
import { getSchedules } from 'reducks/schedule/selectors'
import { FirebaseDocRefType } from 'firebase/index'
import { ScheduleType } from 'types/schedule'

type Props = {
  breadRef: FirebaseDocRefType
  breadName: string
  handleExpandedBreadIds?: (id: string) => void
  isExpandedPrint?: boolean
  isPrintPage?: boolean
  manufacturerName: string
  pickupableTimes: PickupableTimeType[]
  storeName: string
}

const OrderBreadListItem: FC<Props> = (props) => {
  const {
    breadRef,
    breadName,
    handleExpandedBreadIds,
    isExpandedPrint,
    isPrintPage,
    manufacturerName,
    pickupableTimes,
    storeName,
  } = props

  const schedules: ScheduleType[] = useSelector((state: State) => getSchedules(state))

  const [open, setOpen] = useState<boolean>(false)
  const toggleOpen = () => {
    setOpen((prevState) => !prevState)
    handleExpandedBreadIds?.(breadRef.id)
  }

  const totalQuantity = useMemo(() => {
    return pickupableTimes.reduce((prev, pickupableTime) => {
      return (
        prev +
        pickupableTime.choices.reduce((_prev, choice) => {
          return _prev + choice.quantity
        }, 0)
      )
    }, 0)
  }, [pickupableTimes])

  const hasSomePickupableTimesOrOptions = useMemo(() => {
    return schedules
      .filter((schedule) => schedule.bread_ref.id === breadRef.id)
      .some((schedule) => schedule.choices.length > 1 || schedule.default_stocks.length > 1)
  }, [breadRef, schedules])

  if (totalQuantity === 0) return <></>

  return (
    <div className={classNames(styles.order__row, { [styles.open]: open || isPrintPage })}>
      <label
        className={classNames({
          [styles.order__label__print]: isPrintPage,
          [styles.order__label]: !isPrintPage,
          [styles.order__label_multi]: hasSomePickupableTimesOrOptions,
        })}
        onClick={hasSomePickupableTimesOrOptions ? toggleOpen : () => null}
      >
        <span className={styles.order__label__cell}>
          {breadName}
          {manufacturerName !== storeName && `（${manufacturerName}）`}
        </span>
        <span className={styles.order__label__cell}>{totalQuantity}</span>
      </label>
      {((isExpandedPrint && isPrintPage) || !isPrintPage) && <OrderBreadTimeList pickupableTimes={pickupableTimes} />}
    </div>
  )
}

export default OrderBreadListItem
